import { Directive, HostListener, Input, inject } from '@angular/core';
import { MappService } from '../providers/mapp.service';

@Directive({
  selector: '[appTrackClick]',
  standalone: true,
})
export class TrackClickDirective {

  @Input() public appTrackClick!: string;

  private mappService = inject(MappService);

  @HostListener('click')
  protected onClick(): void {
    this.mappService.trackClick(this.appTrackClick);
  }

}
